import useGetTeams from '@/services/api/team/useGetTeams.js'
import useAuthStore from '@/store/useAuthStore'
import { Navigate, Outlet } from 'react-router-dom'

export default function LoginRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  const { data, status } = useGetTeams(isAuthenticated)

  if (!isAuthenticated) return <Outlet />

  if (status === 'pending') return <div>loading....</div>

  if (status === 'success' && data.length === 0) return <Navigate to="/setup" />
  if (status === 'success' && data.length > 0) return <Navigate to={'/'} />

  return <Outlet />
}
